import OnlinePrintForm from './scripts';
import './styles/onlinePrint.scss';

OnlinePrintForm.init();
